import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { AUTOMATIC_EXPIRATION_PROMOTION_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getAutomaticExpirationPromotionSettingsAction = createAsyncThunk(
    'price/getAutomaticExpirationPromotionSettingsAction',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(AUTOMATIC_EXPIRATION_PROMOTION_SETTINGS_PATH);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getAutomaticExpirationPromotionSettingsSlice = createSlice({
    name: 'getAutomaticExpirationPromotionSettingsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getAutomaticExpirationPromotionSettingsAction.pending, () => STATE__API__STARTED);
        builder.addCase(getAutomaticExpirationPromotionSettingsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getAutomaticExpirationPromotionSettingsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getAutomaticExpirationPromotionSettingsState = (state) => state.price.getAutomaticExpirationPromotionSettings;
export default getAutomaticExpirationPromotionSettingsSlice.reducer;